import { RootState, ThunkDispatch } from "core-integration/src/store";
import {
  getElementsById,
  getElementsEventDataById,
} from "core-integration/src/store/elements/reducers";
import { fetchEventLive } from "core-integration/src/store/elements/thunks";
import {
  getEntry,
  getEntryEventFormation,
  getEntryEventPicks,
  getEntryEventPoints,
} from "core-integration/src/store/entries/reducers";
import {
  fetchEntryEventPicks,
  fetchEntrySummary,
} from "core-integration/src/store/entries/thunks";
import { IPickLight } from "core-integration/src/store/entries/types";
import {
  getCurrentEvent,
  getEventsById,
} from "core-integration/src/store/events/reducers";
import { getFixturesForEventById } from "core-integration/src/store/fixtures/reducers";
import { fetchFixtures } from "core-integration/src/store/fixtures/thunks";
import { getRules } from "core-integration/src/store/game/reducers";
import { IRules } from "core-integration/src/store/game/types";
import { getPlayerData } from "core-integration/src/store/player/reducers";
import { IPlayer } from "core-integration/src/store/player/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import range from "lodash/range";
import { hideVisually, size } from "polished";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink, useParams } from "react-router";
import { Box } from "rebass/styled-components";
import styled, { css } from "styled-components/";
import BaseDreamTeam from "../../img/icons/dreamteam.svg?react";
import BaseReload from "../../img/icons/reload.svg?react";
import { ChipName, getChipName } from "../../utils/chips";
import ButtonLink from "../ButtonLink";
import Entry from "../Entry";
import Fixtures from "../Fixtures";
import { ControlArrowLeft, ControlArrowRight } from "../icons/Arrows";
import DreamTeam from "../icons/DreamTeam";
import { Main, Secondary, Wrapper } from "../Layout";
import Link from "../Link";
import {
  EventPager,
  PagerButton,
  PagerButtonNext,
  PagerHeading,
} from "../Pager";
import { ElementRow } from "../Pitch";
import { NotFound } from "../Routes";
import Table from "../Table";
import TabPanel from "../tabs/TabPanel";
import Tabs from "../tabs/Tabs";
import Title from "../Title";
import BenchUnit from "./BenchUnit";
import ElementExplainDialog from "./ElementExplainDialog";
import EntryEventTable from "./EntryEventTable";
import PitchFormation from "./PitchFormation";
import PitchWrapper from "./PitchWrapper";
import valueForPlayerElement from "./valueForPlayedElement";

const StyledTitle = styled(Title)`
  font-size: 2.2rem;
  white-space: normal;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    font-size: 3.2rem;
  }
`;

const PointsScoreboardWrap = styled.div`
  margin: ${({ theme }) => theme.space[2]};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radii[0]};
  background: ${({ theme }) => theme.colors.backgroundwhite50};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin: ${({ theme }) => `${theme.space[3]} ${theme.space[0]}`};
  }
`;

const StyledEventPager = styled(EventPager)`
  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding: 0 23%;
  }
`;

const StyledPagerHeading = styled(PagerHeading)`
  margin-bottom: -2.4rem;
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[5]};
  text-align: center;
  padding: 1rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-bottom: -2rem;
    padding: 1.8rem 0;
  }
`;

const PagerButtonStyles = css`
  flex-basis: 10%;
  margin-top: ${({ theme }) => `-${theme.space[4]}`};
  font-family: ${({ theme }) => theme.fonts.impactMedium};

  > a {
    min-width: 110px;
    padding: 0.6rem 1.5rem;
    border-radius: 40px;
    background-color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes[3]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    margin-top: 0.3rem;
  }
`;

const StyledPagerButton = styled(PagerButton)`
  ${PagerButtonStyles};
`;

const StyledPagerButtonNext = styled(PagerButtonNext)`
  ${PagerButtonStyles};
`;

const DreamTeamWrap = styled.div`
  width: 60%;
  margin: ${({ theme }) => theme.space[4]} auto;
  font-weight: 600;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    width: 40%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    width: 30%;
  }
`;

const TableWrap = styled.div`
  margin-bottom: ${({ theme }) => theme.space[2]};
`;

const PointsScoreboard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: ${({ theme }) => theme.space[3]} 0;
  text-align: center;
`;

const ScoreboardPrimary = styled.div`
  flex: 0 0 38%;
  border: 1px solid ${({ theme }) => theme.colors.greyDarker4};
  border-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.greyDarker2};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    flex-basis: calc(22% - ${({ theme }) => theme.space[1]});
  }
`;

interface IPrimaryPanelProps {
  chipPlayed?: boolean;
}

const PrimaryPanel = styled.div<IPrimaryPanelProps>`
  position: relative;
`;

const PrimaryHeading = styled.h4`
  margin: 0;
  padding-top: ${({ theme }) => theme.space[3]};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  font-weight: 300;

  @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
    padding-top: ${({ theme }) => theme.space[3]};
  }
`;

const PrimaryValue = styled.div`
  position: relative;
  font-family: ${({ theme }) => theme.fonts.impact};
  font-size: ${({ theme }) => theme.fontSizes[7]};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    font-size: ${({ theme }) => theme.fontSizes[6]};
  }
`;

const ReloadButton = styled.button`
  position: absolute;
  top: 50%;
  left: ${({ theme }) => theme.space[0]};
  transform: translateY(-50%);
  padding: ${({ theme }) => theme.space[1]};
  border: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  line-height: 1;
  cursor: pointer;
`;

const Reload = styled(BaseReload)`
  fill: ${({ theme }) => theme.colors.black};
`;

const ReloadButtonText = styled.span`
  ${hideVisually()}
`;

const ScoreboardSecondary = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const SecondaryPanel = styled.div`
  flex: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    display: flex;
    justify-content: space-around;
  }
`;

const SecondaryItem = styled.div`
  overflow: auto;
  text-align: center;
`;

const SecondaryHeading = styled.h4`
  margin: ${({ theme }) => theme.space[1]} 0;
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[0]};
  font-weight: 300;
`;

const SecondaryValue = styled.div`
  margin: ${({ theme }) => `${theme.space[1]} ${theme.space[0]}`};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: 2.2rem;

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    font-family: ${({ theme }) => theme.fonts.impact};
    font-size: 2.4rem;
  }
`;

const DreamTeamLinkIcon = styled(BaseDreamTeam)`
  ${size(16)}
  margin-right: ${({ theme }) => theme.space[1]};
  color: ${({ theme }) => theme.colors.white};
  fill: ${({ theme }) => theme.colors.red};
`;

const DreamTeamLink = styled(RouterLink)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: ${({ theme }) => theme.space[1]};
  border-radius: 15px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.red};
  text-decoration: none;
`;

const ChipStatus = styled.div`
  padding: 1.6rem ${({ theme }) => theme.space[2]};
  border-bottom-left-radius: ${({ theme }) => theme.radii[1]};
  border-bottom-right-radius: ${({ theme }) => theme.radii[1]};
  background-color: ${({ theme }) => theme.colors.blue};
  font-size: 1.1rem;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
`;

type Props = WithTranslation;

const EntryEvent = ({ t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const [pickForMenu, setPickForMenu] = useState<IPickLight | null>(null);
  const params = useParams();
  const entryId = Number(params.entryId);
  const eventId = Number(params.eventId);
  const player = useSelector(getPlayerData) as IPlayer;
  const elementsById = useSelector(getElementsById);
  const elementsDataById = useSelector((state: RootState) =>
    getElementsEventDataById(state, eventId),
  );
  const entry = useSelector((state: RootState) => getEntry(state, entryId));
  const event = useSelector(
    (state: RootState) => getEventsById(state)[eventId],
  );
  const now = useSelector(getCurrentEvent);
  const entryData = useSelector((state: RootState) =>
    getEntryEventPicks(state, entryId, eventId),
  );
  const fixturesById = useSelector((state: RootState) =>
    getFixturesForEventById(state, eventId),
  );
  const formation = useSelector((state: RootState) =>
    getEntryEventFormation(state, entryId, eventId),
  );
  const points = useSelector((state: RootState) =>
    getEntryEventPoints(state, entryId, eventId),
  );
  const rules = useSelector(getRules) as IRules;
  const teamsById = useSelector(getTeamsById);
  const mine = Boolean(player && player.entry && player.entry === entryId);

  const handleShowMenuForPickElement = (element: number) => {
    const matches = entryData!.picks.filter((p) => p.element === element);
    if (matches.length) {
      setPickForMenu(matches[0]);
    }
  };

  const handleHideMenuForPick = () => {
    setPickForMenu(null);
  };

  const renderDreamTeam = (pick: IPickLight) =>
    elementsDataById &&
    elementsDataById[pick.element] &&
    elementsDataById[pick.element].stats.in_dreamteam ? (
      <Link to={`/dream-team/${event!.id}`}>
        <DreamTeam />
      </Link>
    ) : null;

  const fetchDataAndFixtures = () => {
    fetchData();
    dispatch(fetchFixtures(Number(eventId)));
  };

  const fetchData = useCallback(() => {
    dispatch(fetchEntrySummary(Number(entryId)));
    dispatch(fetchEntryEventPicks(Number(entryId), Number(eventId)));
    dispatch(fetchEventLive(Number(eventId)));
  }, [dispatch, entryId, eventId]);

  useEffect(() => {
    fetchData();
  }, [entryId, eventId, fetchData]);

  // Handle unknown and unstarted events
  if (!now || !event || event.id > now.id) {
    return <NotFound />;
  }
  if (!entry || !entryData) {
    return null;
  }

  const chipName = entryData.active_chip
    ? getChipName(entryData.active_chip as ChipName, t)
    : "";

  // Create a new function on each render as data could have changed and
  // need to ensure a render of connected subcomponents
  const renderPickValue = valueForPlayerElement({
    elementsById,
    elementsDataById,
    fixturesById,
    teamsById,
  });
  const benchHeading: Record<string, React.ReactNode> = {
    11: <abbr title="Goalkeeper">GK</abbr>,
    12: "1",
    13: "2",
    14: "3",
  };

  // Handle events before the entry started
  return (
    <Wrapper>
      <Main>
        <Box mx={2}>
          <StyledTitle>
            {t("entryEvent.pointsTitle", "Points")} - {entry.name}
          </StyledTitle>
        </Box>
        <PointsScoreboardWrap>
          <StyledPagerHeading>{event.name}</StyledPagerHeading>
          {(event.id > entry.started_event || event.id < now.id) && (
            <StyledEventPager>
              {event.id > entry.started_event && (
                <StyledPagerButton>
                  <ButtonLink
                    to={`/entry/${entry.id}/event/${event.id - 1}`}
                    variant="secondary"
                  >
                    <ControlArrowLeft />
                    {t("entryEvent.previous", "Previous")}
                  </ButtonLink>
                </StyledPagerButton>
              )}
              {event.id < now.id && (
                <StyledPagerButtonNext>
                  <ButtonLink
                    to={`/entry/${entry.id}/event/${event.id + 1}`}
                    variant="secondary"
                  >
                    {t("entryEvent.next", "Next")}
                    <ControlArrowRight />
                  </ButtonLink>
                </StyledPagerButtonNext>
              )}
              {/* Also need to check isn't last event */}
              {mine && event.id === now.id && (
                <StyledPagerButtonNext>
                  <ButtonLink to={`/my-team`} variant="secondary">
                    {t("entryEvent.next", "Next")}
                    <ControlArrowRight />
                  </ButtonLink>
                </StyledPagerButtonNext>
              )}
            </StyledEventPager>
          )}
          <PointsScoreboard>
            <ScoreboardSecondary>
              <SecondaryPanel>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.avgPoints", "Average Pts")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    {event.average_entry_score || "-"}
                  </SecondaryValue>
                </SecondaryItem>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.highestPoints", "Highest Pts")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    {event.highest_scoring_entry ? (
                      <Link
                        to={`/entry/${event.highest_scoring_entry}/event/${event.id}`}
                      >
                        {event.highest_score || "???"}
                      </Link>
                    ) : (
                      "-"
                    )}
                  </SecondaryValue>
                </SecondaryItem>
              </SecondaryPanel>
              <ScoreboardPrimary>
                <Box>
                  <PrimaryPanel chipPlayed={Boolean(chipName)}>
                    <PrimaryHeading>
                      {event.finished
                        ? t("entryEvent.finalPoints", "Final Points")
                        : t("entryEvent.latestPoints", "Latest Points")}
                    </PrimaryHeading>
                    <PrimaryValue>
                      {points}
                      {!event.finished && (
                        <ReloadButton onClick={fetchDataAndFixtures}>
                          <ReloadButtonText>
                            {t("entryEvent.reload", "Reload Points")}
                          </ReloadButtonText>
                          <Reload />
                        </ReloadButton>
                      )}
                    </PrimaryValue>
                  </PrimaryPanel>
                  {chipName && (
                    <ChipStatus>
                      {t("entryEvent.chipPlayed", "{{ chipName }} played", {
                        chipName: chipName,
                      })}
                    </ChipStatus>
                  )}
                </Box>
              </ScoreboardPrimary>
              <SecondaryPanel>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.rdRank", "RD Rank")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    {entryData.entry_history.rank
                      ? entryData.entry_history.rank.toLocaleString()
                      : "-"}
                  </SecondaryValue>
                </SecondaryItem>
                <SecondaryItem>
                  <SecondaryHeading>
                    {t("entryEvent.transfers", "Transfers")}
                  </SecondaryHeading>
                  <SecondaryValue>
                    <Link to={`/entry/${entry.id}/transfers`}>
                      {entryData.entry_history.event_transfers}
                    </Link>{" "}
                    {entryData.entry_history.event_transfers_cost
                      ? `(-${entryData.entry_history.event_transfers_cost} pts)`
                      : ""}
                  </SecondaryValue>
                </SecondaryItem>
              </SecondaryPanel>
            </ScoreboardSecondary>
          </PointsScoreboard>
          <DreamTeamWrap>
            <DreamTeamLink to={`/dream-team/${event.id}`}>
              <DreamTeamLinkIcon />
              {t("entryEvent.dreamTeam", "Dream Team")}
              <ControlArrowRight />
            </DreamTeamLink>
          </DreamTeamWrap>
        </PointsScoreboardWrap>

        {/* TEAM */}
        <PitchWrapper>
          <Box pt={4}>
            <Box mx={2} mb={2}>
              <Tabs centered={true}>
                <TabPanel
                  label={t("entryEvent.pitchView", "Pitch View")}
                  link="pitch"
                >
                  <Box mx={-2} pt={4} mt={2}>
                    <PitchFormation
                      chipName={entryData.active_chip}
                      formation={formation}
                      picks={entryData.picks}
                      renderDreamTeam={renderDreamTeam}
                      renderElementMenu={handleShowMenuForPickElement}
                      renderPickValue={renderPickValue}
                    />
                    <ElementRow>
                      {range(rules.squad_squadplay, rules.squad_squadsize).map(
                        (i) => (
                          <BenchUnit
                            key={i}
                            chipName={entryData.active_chip}
                            heading={benchHeading[i]}
                            pick={entryData.picks[i]}
                            renderDreamTeam={renderDreamTeam}
                            renderElementMenu={() =>
                              handleShowMenuForPickElement(
                                entryData.picks[i].element,
                              )
                            }
                            renderPickValue={renderPickValue}
                          />
                        ),
                      )}
                    </ElementRow>
                  </Box>
                </TabPanel>
                <TabPanel
                  label={t("entryEvent.listView", "List View")}
                  link="list"
                >
                  <Box mb={4} mt={2}>
                    <TableWrap>
                      <EntryEventTable
                        title="Starters"
                        picks={entryData.picks.slice(0, rules.squad_squadplay)}
                        renderElementMenu={handleShowMenuForPickElement}
                        chipName={entryData.active_chip}
                        dataById={elementsDataById}
                      />
                    </TableWrap>
                    <TableWrap>
                      <EntryEventTable
                        title="Substitutes"
                        picks={entryData.picks.slice(rules.squad_squadplay)}
                        renderElementMenu={handleShowMenuForPickElement}
                        chipName={entryData.active_chip}
                        dataById={elementsDataById}
                      />
                    </TableWrap>
                  </Box>
                </TabPanel>
              </Tabs>
            </Box>
          </Box>
        </PitchWrapper>
        {entryData.automatic_subs.length > 0 && (
          <>
            <Box mx={2}>
              <Title>
                {t("entryEvent.automaticSubs", "Automatic Substitutions")}
              </Title>
            </Box>
            <Table>
              <thead>
                <tr>
                  <th>{t("entryEvent.playerOut", "Player out")}</th>
                  <th>{t("entryEvent.playerIn", "Player in")}</th>
                </tr>
              </thead>
              <tbody>
                {entryData.automatic_subs.map((s) => (
                  <tr key={s.element_out}>
                    <td>{elementsById[s.element_out].web_name}</td>
                    <td>{elementsById[s.element_in].web_name}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
        {pickForMenu && (
          <ElementExplainDialog
            elementId={pickForMenu.element}
            eventId={event.id}
            closeDialog={handleHideMenuForPick}
          />
        )}
        <Fixtures eventId={event.id} />
      </Main>
      <Secondary>
        <Entry entryId={entry.id} />
      </Secondary>
    </Wrapper>
  );
};

const translated = withTranslation()(EntryEvent);

export default translated;
